module.exports = __webpack_public_path__ + "static/media/mew-LOCAL.63e631dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/ethereum/mew-LOCAL.png
// module id = 1748
// module chunks = 146